import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import { bool, instanceOf, string } from "prop-types";
import React from "react";
import ActionBillItem from "./ItemRow";
import AcrtionBillTitleColumns from "./TitleColumns";

const ActionBillTable = ({ isDesktop, tabOption, bills, hideButton, isFinished, summary }) => {
    const hasBills = bills?.length > 1;
    const colsClass = (!hideButton && hasBills ? "hasbills" : "") + (isFinished ? "isfinished" : "");

    const gridTableCss = () => {
        let data;
        if (!summary && !isFinished) {
            data = `tablelist transmit ${colsClass}`;
        }
        if (summary && !isFinished) {
            data = `tablelist tablelist-summary transmit ${colsClass}`;
        }
        if (isFinished) {
            data = `tablelist tablelist-ticket-small transmit ${colsClass}`;
        }
        return data;
    };

    return (
        <>
            <ProductList
                fetchingWithPreviousData
                items={bills || []}
                noDataText="global.no.results"
                noFiltersDataText="global.no.results"
                renderItem={(item) => (
                    <GridTable.Container key={`action-bill-item-${item.facturaId.numeroComprobante}`}>
                        <ActionBillItem
                            billItem={item}
                            isDesktop={isDesktop}
                            tabOption={tabOption}
                            showButton={!hideButton && hasBills}
                            isFinished={isFinished}
                        />
                    </GridTable.Container>
                )}>
                {(listItem) => (
                    <>
                        <GridTable className={gridTableCss()}>
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container>
                                        <AcrtionBillTitleColumns
                                            tabOption={tabOption}
                                            isFinished={isFinished}
                                            showButton={!hideButton && hasBills}
                                        />
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body>{listItem}</GridTable.Body>
                        </GridTable>
                    </>
                )}
            </ProductList>
        </>
    );
};

ActionBillTable.propTypes = {
    isDesktop: bool.isRequired,
    tabOption: string.isRequired,
    bills: instanceOf(Array).isRequired,
    hideButton: bool,
    isFinished: bool,
    summary: bool,
};

ActionBillTable.defaultProps = {
    hideButton: false,
    isFinished: false,
    summary: false,
};

export default ActionBillTable;
